import { useSiteConfig } from '../../context/SiteConfigContext'

function extractYoutubeId(url) {
  if (!url) return null
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /^([a-zA-Z0-9_-]{11})$/
  ]
  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) return match[1]
  }
  return null
}

function isSpotInDateRange(start, end) {
  if (!start && !end) return true
  const now = new Date()
  const currentMMDD = `${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
  if (start && !end) return currentMMDD >= start
  if (!start && end) return currentMMDD <= end
  return currentMMDD >= start && currentMMDD <= end
}

function YoutubeSpot({ position, currentPage }) {
  const { siteConfig } = useSiteConfig()
  const { spotEnabled, spotVideoUrl, spotPage, spotPosition, spotStartMonthDay, spotEndMonthDay } = siteConfig

  if (!spotEnabled || !spotVideoUrl) return null
  if (spotPage !== currentPage) return null
  if (spotPosition !== position) return null
  if (!isSpotInDateRange(spotStartMonthDay, spotEndMonthDay)) return null

  const videoId = extractYoutubeId(spotVideoUrl)
  if (!videoId) return null

  return (
    <section className="py-12 bg-neutral-50 border-y border-neutral-100">
      <div className="container-custom">
        <div className="w-full rounded-2xl overflow-hidden shadow-lg" style={{ aspectRatio: '16/9' }}>
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
            title="Spot digital Génika"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  )
}

export default YoutubeSpot
